(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/views/betslip/betslip-payment-footer.js') >= 0) return;  svs.modules.push('/modules/maltipset/views/betslip/betslip-payment-footer.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.maltipset=_svs.maltipset||{};
_svs.maltipset.templates=_svs.maltipset.templates||{};
svs.maltipset.templates.betslip_payment_footer = Handlebars.template({"0":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"payment-footer-balance align-center fc-grey-500\">\n    <span>Saldo:</span>\n    <span id=\"betslip-account-balance\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"accountBalance") || (depth0 != null ? lookupProperty(depth0,"accountBalance") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"accountBalance","hash":{},"data":data,"loc":{"start":{"line":6,"column":39},"end":{"line":6,"column":57}}}) : helper)))
    + " kr</span>\n  </div>\n";
},"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = 
  "  ";
  stack1 = ((helper = (helper = lookupProperty(helpers,"isSelfService") || (depth0 != null ? lookupProperty(depth0,"isSelfService") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"isSelfService","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":11,"column":2},"end":{"line":11,"column":99}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"isSelfService")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "Lägg i varukorg";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "Betala "
    + container.escapeExpression((lookupProperty(helpers,"formatCurrency")||(depth0 && lookupProperty(depth0,"formatCurrency"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"totalCost") : depth0),{"name":"formatCurrency","hash":{},"data":data,"loc":{"start":{"line":11,"column":50},"end":{"line":11,"column":78}}}))
    + " kr";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"padding f-200 row\">\n  <div class=\"account-change-holder\"></div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"accountBalance") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":2},"end":{"line":8,"column":9}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"ui")||(depth0 && lookupProperty(depth0,"ui"))||container.hooks.helperMissing).call(alias1,"button",{"name":"ui","hash":{"value":false,"disabledIf":(depth0 != null ? lookupProperty(depth0,"isValid") : depth0),"class":"btn-block center btn-pay js-btn-pay relative","focus":true,"size":300},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":2},"end":{"line":12,"column":9}}})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true});
Handlebars.partials['svs-maltipset-betslip_payment_footer'] = svs.maltipset.templates.betslip_payment_footer;
})(svs, Handlebars);


 })(window);